module.exports = __webpack_public_path__ + "img/breath@2x.f963db71.png";